import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DialogData } from "../skill-repo-employee-tiles/skill-repo-employee-tiles.component";

@Component({
  selector: 'app-confimation-popup',
  template: `<div><h1 mat-dialog-title>Confirmation Message</h1>    
    <div mat-dialog-content>
    {{message}}
    </div>
    <div mat-dialog-actions class="justify-content-end">
    <button mat-dialog-close class="btn ml-2 mr-2 custom_btn inverted_btn_base">No</button>
      <button (click)="onProceedClick()" class="btn custom_btn primary_btn_base d-flex align-items-center ml-2">
      Proceed</button>
    </div>
    </div>
    `,
  styles: ['.adjust{padding-bottom: 45px;}'],
})
export class ConfirmationPopupComponent implements OnInit {
  message: string;
  header: string;
  constructor(
    public dialogRef: MatDialogRef<ConfirmationPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.dialogRef.updateSize('30%', '22%');
    this.message = this.data.message;
  }

  onNoClick(): void {
    this.dialogRef.close("No");
  }
  onProceedClick(): void {
    this.dialogRef.close("success");
  }
}